import React from 'react';
import {TextField} from "@mui/material";
import {PanelAvailabilityStatusSelect} from "../../components/MaterialSelects/PanelAvailabilityStatusSelect";
import {DistributorSelect} from "../../components/MaterialSelects/DistributorSelect";
import {BoroughSelect} from "../../components/MaterialSelects/BoroughSelect";
import {PanelPackSelect} from "../../components/MaterialSelects/PanelPackSelect";
import {RegionSelectGrouped} from "../../components/MaterialSelects/RegionSelectGrouped";
import {RegionTypeSelect} from "../../components/MaterialSelects/RegionTypeSelect";
import {SiteStructureSelect} from "../../components/MaterialSelects/SiteStructureSelect";
import {SubletterSelect} from "../../components/MaterialSelects/SubletterSelect";
import {IsoDateRangePicker} from "../../components/IsoDateRangePicker";
import {IsoDatePicker} from "../../components/IsoDatePicker";
import {PostcodeAreaSelect} from "../../components/MaterialSelects/PostcodeAreaSelect";
import {SiteTagSelect} from "../../components/MaterialSelects/SiteTagSelect";
import SearchForm from "../../components/search-form";
//import {SiteTagSelect} from "../../components/MaterialSelects/SiteTagSelect";

class SiteSearch extends React.Component {
    static fieldTypes = [
        {
            label: 'Name', id: 'name',
            default: true,
            variants: [
                {
                    default: true,
                    label: 'Like',
                    id: 'like',
                    editor: ({input}) =><TextField {...input} autoComplete="site-name" label="Name"/>
                },
            ]
        },
        {
            label: 'Site Tags', id: 'tags',
            variants: [
                {
                    default: true,
                    label: 'Lookup',
                    multi: true,
                    id: 'in',
                    editor: ({input}) => <SiteTagSelect  {...input} multiple={true} valueIsId={true} label="Tags" />
                },
            ]
        },
        {
            label: 'Status', id: 'status',
            variants: [
                {
                    default: true,
                    label: 'Lookup',
                    multi: true,
                    id: 'in',
                    editor: ({input}) => <PanelAvailabilityStatusSelect {...input} multiple={true} valueIsId={true} label="Status" />
                },
            ]
        },{
            label: 'Address', id: 'address1',
            variants: [{
                label: 'Like',
                id: 'like',
                editor: ({input}) =><TextField {...input} />
            }
            ]
        },{
            label: 'Distributor', id: 'distributor',
            variants: [{
                label: 'Lookup',
                id: 'in',
                multi: true,
                getValue:(e)=>e?e.id:undefined,
                editor: ({input}) =><DistributorSelect valueIsId={true} {...input} multiple={true} />
            }
            ]
        },{
            label: 'Borough', id: 'borough',
            variants: [{
                label: 'Lookup',
                id: 'in',
                getValue:(e)=>e?e.id:undefined,
                multi: true,
                editor: ({input}) =><BoroughSelect multiple={true} {...input} valueIsId={true}/>
            }
            ]
        },{
            label: 'Pack', id: 'pack',
            variants: [{
                id: 'in',
                label: 'Lookup',
                clearOnChange: true,

                multi: true,
                editor: ({input}) => <PanelPackSelect multiple={true} valueIsId={true} {...input} popup={true}/>
            }]
        },{
            label: 'Region', id: 'regionId',
            variants: [{
                id: 'in',
                label: 'Lookup',
                clearOnChange: true,
                multi: true,
                editor: ({input}) => <RegionSelectGrouped multiple={true} valueIsId={true} {...input}/>
            }]
        }, {
            label: 'Region Type', id: 'region_type',
            variants: [
              {
                id: 'in',
                label:'Lookup',
                getValue:(e)=>e?e.id:undefined,
                multi: true,
                editor: ({input}) => <RegionTypeSelect multiple={true} valueIsId={true} {...input} />
              }
            ]
          }, {
            label: 'Site Structure', id: 'structureId',
            variants: [{
                id: 'in',
                label: 'Lookup',
                getValue: (val) => {
                    return val.id;
                },
                multi: true,
                editor: ({input}) =><SiteStructureSelect multiple={true} {...input} valueIsId={true}/>
            }]
        }, {
            label: 'Postcode', id: 'postcode',
            variants: [{
                id:'rlike',
                label:'Lookup',
                clearOnChange: false,
                editor:({input})=><PostcodeAreaSelect valueIsId={true} {...input}/>
            },{
                id: 'prefix',
                label: 'Starts with',
                clearOnChange: false,
                editor: ({input}) => <TextField {...input} placeholder="Prefix"/>
            }]
        }, {
            label: 'Sublet from', id: 'subletterId',
            variants: [
                {
                    id: 'in',
                    label: 'Lookup',
                    clearOnChange: true,
                    getValue: (val) => {
                        return val.id;
                    },
                    multi: true,
                    editor: ({input}) => <SubletterSelect multiple={true} {...input} valueIsId={true} />
                }
            ]
        }, {
            label: "Site Code", id: 'site_code',
            variants: [
                {
                    id: 'like',
                    label: 'Like',
                    editor: ({input}) => <TextField label="Site Code" {...input}/>
                }

            ]
        }, {
            label: "Build Date", id: 'build_date',
            variants: [
                {
                    id: 'range',
                    label: 'Range',
                    editor: ({input}) => <IsoDateRangePicker label="Between" {...input}/>
                },
                {
                    id: 'exact',
                    label: 'Exact',
                    editor: ({input}) => <IsoDatePicker {...input} label="Date"/>
                }

            ]
        }
    ];

    render() {
        return <SearchForm onCancel={this.props.onCancel} onSearch={this.props.onSearch} isOpen={this.props.isOpen}
                           params={this.props.params}
                           fieldTypes={SiteSearch.fieldTypes}
                           name="sites"
                           label="Sites "
        />
    }
}

export default SiteSearch;
